import { useQuery } from '@apollo/client';
import { GetPlansPricingDocument } from '@upheal/graphql/definitions/billing/GetPlansPricing.generated';
import { captureException } from '@upheal/shared/utils/sentry';

export const usePlansPricing = () => {
    const { data: pricingData, loading: loadingPricingData } = useQuery(
        GetPlansPricingDocument,
        {
            notifyOnNetworkStatusChange: true,
            onError: (error) => {
                captureException('Failed to fetch pricing data', { error });
            },
        },
    );

    return {
        pricingData: pricingData?.getPlansPricing,
        groupPricing: pricingData?.getPlansPricing?.groupPricing,
        currency: pricingData?.getPlansPricing?.currency.toUpperCase(),
        loadingPricingData,
    };
};
